module.exports = __webpack_public_path__ + "media/images/athletes/3506-e5d0e31bfb40e3d85163f919d49362d4.png";